module.exports = __webpack_public_path__ + "img/img-box-2021-left.7c6bc011.png";